import { render, staticRenderFns } from "./lawyer.vue?vue&type=template&id=617d5884&scoped=true"
import script from "./lawyer.vue?vue&type=script&lang=js"
export * from "./lawyer.vue?vue&type=script&lang=js"
import style0 from "./lawyer.vue?vue&type=style&index=0&id=617d5884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617d5884",
  null
  
)

export default component.exports